import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Tarea/Create',
  documento: 'crm',
  filas: ['139'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/TareaController.cs',
} satisfies RutaProd;
